module.exports = __webpack_public_path__ + "public/Icons/storeLogin.svg?f970dafc";